import React, { useContext, useMemo } from 'react';
import { stVars as spacingStVars } from '../Foundation/stylable/spacing.st.css';
import { st, classes } from './Layout.st.css';
import { LayoutProps } from './Layout.types';
import { WixDesignSystemContext } from '../WixDesignSystemProvider/context';

const formatSpacingValue = (value: string | number): string => {
  if (typeof value === 'number') {
    return `${value}px`;
  }

  return spacingStVars[value] || `${value}`;
};

const Layout: React.FC<LayoutProps> = ({
  children,
  gap = '24px',
  cols,
  justifyItems,
  alignItems,
  rowHeight = 'auto',
  dataHook,
  height,
  className,
}) => {
  const { mobile } = useContext(WixDesignSystemContext);

  const resolvedCols = mobile ? 1 : cols;

  const smartGap = useMemo(() => formatSpacingValue(gap), [gap]);

  return (
    <div
      data-hook={dataHook}
      data-gap={smartGap}
      style={{
        height,
        gap: smartGap,
        justifyItems,
        alignItems,
        gridAutoRows: rowHeight,
        gridTemplateColumns: resolvedCols
          ? `repeat(${resolvedCols}, minmax(0, 1fr))`
          : undefined,
      }}
      className={st(classes.root, className)}
      children={children}
    />
  );
};

Layout.displayName = 'Layout';

export { Layout };
